// extracted by extract-css-chunks-webpack-plugin
module.exports = {"paragraph":"css-1hGTU40OlW","paragraph__story":"css-1AonNJUvaB","paragraph__style":"css-2xWl7KmAoU","paragraph__light":"css-2E418A4cI7"};